import styled from 'styled-components';

export const WaitingContainer = styled.div`
  width: 100%;
  height: 468px;
  text-align: center;
  > img {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
`;
